import { useCallback, useEffect, useState } from 'react';
import { listDirectoryTags, type DirectoryTagKind, type DirectoryTagView } from '../features/directory-tags/directory-tags.api';

/**
 * One catalogue (a garage's service types, a supplier's categories), fetched once and re-fetched with `refresh`
 * after a save that may have added entries on the fly. A failed fetch leaves it empty: the screens still work,
 * their pickers just open without choices.
 */
export function useDirectoryTags(kind: DirectoryTagKind) {
  const [tags, setTags] = useState<DirectoryTagView[]>([]);

  const refresh = useCallback(
    () =>
      listDirectoryTags(kind)
        .then(setTags)
        .catch(() => undefined),
    [kind],
  );

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { tags, refresh };
}
